import React, { useState } from "react";
import Couponsdata from "./Couponsdata";
import Userscouponcreation from "./Userscouponcreation";

const Vendorusercomponstab = () => {
    const [activeTab, setActiveTab] = useState("Users");

    return (
        <div className="tabs-wrapper">

            {/* Tabs */}
            <div className="tabs-row">
                <span
                    className={`row-tab ${activeTab === "Users" ? "active" : ""}`}
                    onClick={() => setActiveTab("Users")}
                >
                    Vendor
                </span>

                <span
                    className={`row-tab ${activeTab === "Professional Users" ? "active" : ""}`}
                    onClick={() => setActiveTab("Professional Users")}
                >
                    Users
                </span>
            </div>

            {/* Content */}
            <div
                className="tabs-content"
                style={{
                    overflowY: "auto",
                    scrollbarWidth: "none",
                    height: "calc(85vh - 120px)",
                    marginTop: "20px"
                }}
            >
                {activeTab === "Users" ? (
                    <Couponsdata />
                ) : (
                    <Userscouponcreation />
                )}
            </div>
        </div>
    );
};

export default Vendorusercomponstab;